import { Grid, Button, Accordion, AccordionDetails, AccordionSummary, Typography } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import { utilFunctions } from "../../../_helpers";
import { studyBrowserActions } from "../../../_redux/actions";
import { DownloadFactoryStudySummaryReportParams } from "../../../_models/app.models";
import moment from "moment";
import { ExpandMore } from "@material-ui/icons";
import FormControlWrapper from "../../_shared/FormControlWrapper";

const FactoryStudySummary = (props) => {
    const labelMinWidth = 85
    const INITIAL_STATE = {
        fromDate: { value: null, validator: 'text', isRequired: true, error: null, disable: false },
        endDate: { value: null, validator: 'text', isRequired: true, error: null, disable: false }
    }
    const dispatch = useDispatch();
    const [filterState, setFilterState] = useState(INITIAL_STATE);
    const [filtersAccordion, setFiltersAccordion] = useState(true)

    const onFilterClear = () => {
        setFilterState(INITIAL_STATE)
    }

    const onDownloadReport = async () => {
        const [validatedData, isValid]: any = await utilFunctions.validateFormData(filterState)
        setFilterState(validatedData)

        if (isValid) {
            const params: DownloadFactoryStudySummaryReportParams = {
                endDate: moment(validatedData.endDate.value).format('YYYY-MM-DD'),
                startDate: moment(validatedData.fromDate.value).format('YYYY-MM-DD')
            }
            dispatch(studyBrowserActions.downloadFactoryStudySummaryReport(params))
        }
    }
    const handleFromDateChange = (date: Date | null) => {
        setFilterState({
            ...filterState,
            fromDate: {
                ...filterState.fromDate,
                value: date,
                error: null
            },
            endDate: {
                ...filterState.endDate,
                value: null
            }
        })
    }
    const handleEndDateChange = (date: Date | null) => {
        setFilterState({
            ...filterState,
            endDate: {
                ...filterState.endDate,
                value: date,
                error: null
            }
        })
    }

    return (
        <React.Fragment>
            <Accordion
                className="appAccordion"
                expanded={filtersAccordion}
                onChange={(e, expanded) => setFiltersAccordion(expanded)}
            >
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>Filters</Typography>
                </AccordionSummary>
                <AccordionDetails className="contentPadding">
                    <Grid container spacing={3} className="appFilterContainer">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid item xs={12} sm={12} md={6} lg={3} >
                                <FormControlWrapper label="From Date" variant="inline" labelMinWidth={labelMinWidth} isRequired={filterState.fromDate.isRequired}>
                                    <KeyboardDatePicker
                                        variant="inline"
                                        format="MM/dd/yyyy"
                                        margin="none"
                                        size="small"
                                        id="date-picker-inline"
                                        inputVariant="outlined"
                                        value={filterState.fromDate.value}
                                        error={!!filterState.fromDate.error}
                                        onChange={handleFromDateChange}

                                    />
                                </FormControlWrapper>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={3} >
                                <FormControlWrapper label="End Date" variant="inline" labelMinWidth={labelMinWidth} isRequired={filterState.endDate.isRequired}>
                                    <KeyboardDatePicker
                                        variant="inline"
                                        format="MM/dd/yyyy"
                                        margin="none"
                                        size="small"
                                        id="date-picker-inline"
                                        inputVariant="outlined"
                                        value={filterState.endDate.value}
                                        minDate={filterState.fromDate.value}
                                        maxDate={moment(filterState.fromDate.value).add(30, 'days')}
                                        disabled={!filterState.fromDate.value}
                                        error={!!filterState.endDate.error}
                                        onChange={handleEndDateChange}

                                    />
                                </FormControlWrapper>
                            </Grid>
                        </MuiPickersUtilsProvider>
                        <Grid item xs={12} sm={12} md={6} lg={3} className="appButtonGroup">
                            <Button variant="contained" onClick={onFilterClear}>Clear</Button>
                            <Button variant="contained" color="primary" onClick={onDownloadReport}>Download</Button>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </React.Fragment>
    )
}

export default FactoryStudySummary